import generateActions from './baseAction';
import API from '../api';
import * as actions from '../constants';

const {
  requestGetPostcode,
  receiveGetPostcode,
} = generateActions('postcode', 'postcodes');

/**
 * Get addresses for a postcode
 * @param {String} postcode
 * @return {Promise}
 */
const getPostcode = (postcode: string) => (
  (dispatch) => {
    dispatch(requestGetPostcode());
    return API.request(`/postcodes/${postcode}`)
    .then(response => response.json())
    .then((response) => {
      dispatch(receiveGetPostcode(response.error, response.data, new Date()));
      return response;
    });
  }
);

export {
  getPostcode,
};
